import { calculateArea } from "@nova/calculate-geospatial"
import { decodeNumberToColor } from "@nova/serializer/src/client/util"
import { selectFirePerimeterById } from "features/entity-caching/fire-perimeters/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useMemo } from "react"
import { getSVGFromCoordinates } from "../generics/genericAssetsListThumbnails"

export function FirePerimeterAssetsThumbnail({ id }: { id: string }) {
    const perimeter = useAppSelector(selectFirePerimeterById(id))
    const svg = useMemo(() => {
        if (!perimeter.polygons.length) return null
        const largestPolygon = [...perimeter.polygons]
            .map((polygon, i) => ({ ...polygon, index: i }))
            .sort((a, b) => calculateArea(b.coordinates) - calculateArea(a.coordinates))[0]
        return getSVGFromCoordinates({
            points: largestPolygon.coordinates,
            strokeWidth: perimeter.width,
            strokeColor: perimeter.outline ? decodeNumberToColor(perimeter.outline) : undefined,
            isPolygon: true,
        })
    }, [perimeter.outline, perimeter.polygons, perimeter.width])
    return <div className="w-full h-full flex justify-center items-center">{svg}</div>
}
